module.exports = __webpack_public_path__ + "img/dittoReceiverTypes.a7071068.png";